define(["exports", "react", "react-intl-universal", "moment", "moment/locale/pt-br", "styled-components", "../../atoms", "../../utils"], function (_exports, _react, _reactIntlUniversal, _moment, _ptBr, _styledComponents, _atoms, _utils) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _reactIntlUniversal = _interopRequireDefault(_reactIntlUniversal);
  _moment = _interopRequireDefault(_moment);
  _styledComponents = _interopRequireDefault(_styledComponents);

  var WrapperExperienceProfessional = _styledComponents.default.div.withConfig({
    displayName: "Experience__WrapperExperienceProfessional",
    componentId: "sc-3mclqh-0"
  })(["padding:0 16px 0 0;"]);

  var ItemExperience = _styledComponents.default.div.withConfig({
    displayName: "Experience__ItemExperience",
    componentId: "sc-3mclqh-1"
  })(["display:flex;width:100%;+ div{padding:32px 0 0;}"]);

  var IconBuilding = _styledComponents.default.span.withConfig({
    displayName: "Experience__IconBuilding",
    componentId: "sc-3mclqh-2"
  })(["background:", ";border:solid 1px ", ";padding:15px;margin-right:16px;max-height:56px;box-icon{display:block;fill:", ";}"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.white;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.lightGray;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.dark;
  });

  var ExperienceName = (0, _styledComponents.default)(_atoms.H3).withConfig({
    displayName: "Experience__ExperienceName",
    componentId: "sc-3mclqh-3"
  })(["margin:0;span{font-weight:", ";}em{font-style:normal;font-weight:", ";}"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.font.semibold;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.font.regular;
  });
  var ExperienceDescription = (0, _styledComponents.default)(_atoms.Small).withConfig({
    displayName: "Experience__ExperienceDescription",
    componentId: "sc-3mclqh-4"
  })(["line-height:24px;margin:0 0 8px;padding:0;"]);
  var ExperienceDate = (0, _styledComponents.default)(_atoms.Small).withConfig({
    displayName: "Experience__ExperienceDate",
    componentId: "sc-3mclqh-5"
  })(["margin:0;padding:0 0 0 24px;position:relative;@media print{color:", ";font-weight:", ";}span{font-weight:", ";@media print{color:", ";font-weight:", ";}}box-icon{fill:", ";height:16px;left:0;position:absolute;top:2px;width:16px;}"], function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.dark;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.font.bold;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.font.semibold;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.colors.dark;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return theme.font.bold;
  }, function (_ref11) {
    var theme = _ref11.theme;
    return theme.colors.dark;
  });
  var TitleBox = (0, _styledComponents.default)(_atoms.H2).withConfig({
    displayName: "Experience__TitleBox",
    componentId: "sc-3mclqh-6"
  })(["color:", ";font-size:2em;font-weight:", ";line-height:1.6em;margin:0;"], function (_ref12) {
    var theme = _ref12.theme;
    return theme.colors.dark;
  }, function (_ref13) {
    var theme = _ref13.theme;
    return theme.font.semibold;
  });

  var ObjectiveText = _styledComponents.default.p.withConfig({
    displayName: "Experience__ObjectiveText",
    componentId: "sc-3mclqh-7"
  })(["color:", ";font-size:1.4em;line-height:1.71em;margin:0;"], function (_ref14) {
    var theme = _ref14.theme;
    return theme.colors.darkGray;
  });

  var Experience = function Experience(_ref15) {
    var _ref15$experiencias = _ref15.experiencias,
        experiencias = _ref15$experiencias === void 0 ? [] : _ref15$experiencias,
        objective = _ref15.objective;
    return /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: experiencias
    }, /*#__PURE__*/_react.default.createElement(WrapperExperienceProfessional, null, /*#__PURE__*/_react.default.createElement(TitleBox, null, _reactIntlUniversal.default.get('CURRICULUM.EXPERIENCIA_PROFISSIONAL.TITULO')), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
      check: objective
    }, /*#__PURE__*/_react.default.createElement(ObjectiveText, null, _reactIntlUniversal.default.get('CURRICULUM.EXPERIENCIA_PROFISSIONAL.OBJETIVO'), objective), /*#__PURE__*/_react.default.createElement(_atoms.Spacing, null)), experiencias.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement(ItemExperience, {
        key: index
      }, item != null && item.logo ? /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("img", {
        width: "72",
        height: "72",
        alt: item == null ? void 0 : item.empresa,
        src: item == null ? void 0 : item.logo
      })) : /*#__PURE__*/_react.default.createElement(IconBuilding, null, /*#__PURE__*/_react.default.createElement("box-icon", {
        type: "solid",
        name: "building"
      })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(ExperienceName, null, item == null ? void 0 : item.cargo, /*#__PURE__*/_react.default.createElement("em", null, _reactIntlUniversal.default.get('CURRICULUM.EXPERIENCIA_PROFISSIONAL.EM')), item == null ? void 0 : item.empresa), /*#__PURE__*/_react.default.createElement(_atoms.ContentCheck, {
        check: (item == null ? void 0 : item.porte) || (item == null ? void 0 : item.nacionalidade) || (item == null ? void 0 : item.pais) || (item == null ? void 0 : item.segmento)
      }, /*#__PURE__*/_react.default.createElement(ExperienceDescription, null, item == null ? void 0 : item.porte, " ", item == null ? void 0 : item.nacionalidade, " (", item == null ? void 0 : item.pais, ")", _reactIntlUniversal.default.get('CURRICULUM.EXPERIENCIA_PROFISSIONAL.DE'), item == null ? void 0 : item.segmento)), /*#__PURE__*/_react.default.createElement(ExperienceDescription, null, /*#__PURE__*/_react.default.createElement(_atoms.FormatText, {
        texts: item == null ? void 0 : item.descricao_experiencia
      })), /*#__PURE__*/_react.default.createElement(ExperienceDate, null, /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("box-icon", {
        name: "time"
      }), (0, _moment.default)(item == null ? void 0 : item.data_inicio).format('MMMM/YYYY'), ' ', !(item != null && item.data_fim) ? /*#__PURE__*/_react.default.createElement("span", null, "- atualmente") : _reactIntlUniversal.default.get('CURRICULUM.EXPERIENCIA_PROFISSIONAL.ATE', {
        date: (0, _moment.default)(item == null ? void 0 : item.data_fim).format('MMMM/YYYY')
      })), ' - ', (0, _utils.timeCounter)(item == null ? void 0 : item.data_inicio, item == null ? void 0 : item.data_fim), ' ', _reactIntlUniversal.default.get('CURRICULUM.EXPERIENCIA_PROFISSIONAL.TEMPO_EMPRESA'))));
    })));
  };

  Experience.defaultProps = {
    empresa: '',
    cargo: '',
    objective: ''
  };
  var _default = Experience;
  _exports.default = _default;
});